export const ageRequirement: number = 18;